module.exports = __webpack_public_path__ + "img/sect4-333.5716fce5.png";